//service
import http from "./httpService";
import config from "./config"



//service 
export const service = () => {
    return http.get(
        `${config.apiAddress}other/service`,
    );
};

//aboutUs 
export const aboutUs = () => {
    return http.get(
        `${config.apiAddress}other/aboutUs`,
    );
};

//contactUs 
export const contactUs = () => {
    return http.get(
        `${config.apiAddress}other/contactUs`,
    );
};